function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { ConfirmationModal } from "../ConfirmationModal";
import { useGlobalContext } from "../GlobalContext";
export function UnsavedChangesModal(props) {
  const {
    testid,
    title = 'Unsaved changes',
    primaryButtonLabel = 'Discard changes',
    primaryButtonTestId,
    secondaryButtonTestId,
    content = 'You have unsaved changes that will be lost if you leave this page',
    dismissModal
  } = props;
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    "data-testid": testid,
    skin: "danger",
    title: title,
    content: content,
    primaryButtonLabel: primaryButtonLabel,
    secondaryButtonLabel: "Keep editing",
    primaryButtonTestid: primaryButtonTestId,
    secondaryButtonTestid: secondaryButtonTestId,
    onPrimaryButtonClick: () => dismissModal(true),
    onSecondaryButtonClick: () => dismissModal(false)
  });
}
export function useOpenUnsavedChangesModal() {
  const globalContext = useGlobalContext();
  return function openUnsavedChangesModal(props) {
    return globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(UnsavedChangesModal, _extends({}, props, {
          dismissModal: dismissModal
        }));
      }
    });
  };
}